<template>
    <div>
        
            <q-modal v-model="dialogVisible" no-backdrop-dismiss>    
                <q-toolbar color="primary" style="justify-content:space-between;" class='contragent-dialog'>
                    <q-toolbar-title shrink>
                        Редактирование пользователя
                    </q-toolbar-title>
                </q-toolbar>       
                <form action="#" @submit.prevent="okDialog">  
                    <div class="dialog-container">

                        <div class="q-ma-lg">
                            <q-input v-model="data.name" label="Имя пользователя" placeholder="Имя пользователя"/>
                        </div>
                        <div class="q-ma-lg">
                            <q-input v-model="data.surname" label="Фамилия пользователя" placeholder="Фамилия пользователя"/>
                        </div>

                        <div class="q-ma-lg">
                            <q-input v-model="data.email" label="e-mail пользователя" placeholder="e-mail пользователя (login)"/>
                        </div>
 
                        <div class='params-container q-ma-sm q-pa-sm round-borders q-mt-lg' style="border: 1px dotted gray;">
                            <div class="q-ma-lg">
                                <q-input v-model="data.password" type="password" label="пароль" placeholder="введите пароль"/>
                            </div>
                            <div class="q-ma-lg">
                                <q-input v-model="data.password_confirm" type="password" label="пароль" placeholder="повторите пароль"/>
                            </div>

                            <div class="q-ma-lg">
                                <q-select
                                        multiple
                                        v-model="data.permissions"
                                        placeholder="Назначенные роли"
                                        separator
                                        clearable
                                        :options="rolesList"
                                        filter
                                        class="fit"
                                    />
                            </div>


                        </div>
                      
                    </div>
                    <div class="button-container row no-wrap q-ma-md gutter-sm justify-end ">
                        <q-btn label="отмена" icon="cancel" color="negative" outline  class="q-ma-sm" @click="cancelDialog" :disable='loading'/>
                        <q-btn label="сохранить" icon="save" color="positive" class="q-ma-sm" type="submit" :loading='loading' style="width:150px;"/>
                    </div>
                </form>
            </q-modal>
        
    </div>    
</template>

<script>
/* eslint-disable */
export default {
    name : 'userEditDialog',

    data() {
        return {

            dialogVisible : false,
            data : {},
            emptyData : {
                id : -1,
                name : '',
                surname : '',
                email : '',
                password : '',
                password_confirm : '',
                permissions : [],
            },
            loading : false,
        }
    },

    created() {
        eventBus.$on('openUserEditDialog', this.openDialog);
        this.setEmptyData(); // присваиваем начальные значения диалоговому окну
    },

    beforeDestroy() {
        eventBus.$off('openContragentEditDialog');
    },

    computed : {

        priceList() {
            
            return this.$store.getters.allPrices.map(item => {
                return {
                    label : item.name,
                    value : item.id
                }
            });
        },
        
        rolesList() {
            return this.$store.getters.getRoles.map(item =>{
                return {
                    label : item.title,
                    value : item.id,
                }
            });
        },

    },

    methods : {


        setEmptyData() {
            this.data = Object.assign({}, this.emptyData);
        },

        openDialog(id){

            if (id>-1) { // если редактируем уже существующего контрагента - загружаем данные в него
                var q = this.$store.getters.getUserById(id);
                if (q != undefined) { 
                    this.data = Object.assign({}, q);
                    this.data.permissions = q.roles;
                }
            } else this.setEmptyData(); // иначе обнуляем все поля ввода

            this.dialogVisible = true;

        },

        cancelDialog() {
            this.dialogVisible = false;
        },

        okDialog() {
            if ((this.data.name=='')||(this.data.name.length==0)) {
                this.$admns.showNotify('Необходимо ввести имя пользователя','error','Сообщение системы');
                return;
            }
            if ((this.data.surname==undefined)||(this.data.surname.length==0)) {
                this.$admns.showNotify('Необходимо ввести фамилию пользователя','error','Сообщение системы');
                return;
            }
            if ((this.data.email==undefined)||(this.data.email.length==0)) {
                this.$admns.showNotify('Необходимо ввести email пользователя. Будет использоваться в качестве login','error','Сообщение системы');
                return;
            }

            if (((this.data.password==undefined)||(this.data.password.length==0))&&(this.data.id==-1)) {
                this.$admns.showNotify('Необходимо ввести пароль','error','Сообщение системы');
                return;
            }
            if (((this.data.password_confirm==undefined)||(this.data.password_confirm.length==0))&&(this.data.id==-1)) {
                this.$admns.showNotify('Необходимо повторить пароль','error','Сообщение системы');
                return;
            }
           if (this.data.password_confirm != this.data.password) {
                this.$admns.showNotify('Введеные пароли не одинаковы','error','Сообщение системы');
                return;
            }
           if (this.data.permissions.length==0) {
                this.$admns.showNotify('Ни одна роль не выбрана','error','Сообщение системы');
                return;
            }
            this.loading = true;
            this.$store.dispatch('saveUser', this.data)
            .then(()=>{
                this.loading = false;
                this.dialogVisible = false;
                this.$admns.showNotify('Пользователь сохранен','success','Сообщение системы');
            })
            .catch((error)=>{
                this.loading = false;
                console.log(error);
                this.$admns.showNotify('Ошибка сохранения пользователя','error','Сообщение системы');
            });
            
        }


    }


}
</script>

<style lang="scss" scoped>
    .contragent-dialog {
        min-width:600px;
        width : 100%;
    }
    .dialog-container {
        min-height: 250px;
        padding: 20px;
    }
</style>



